module.exports = {
  "native": {
    "UNINSTALLED": 0,
    "OPENABLE": 1,
    "NOTSURE": 2,
    "NEEDUPDATE": 3,
    "DOWNLOADING": 10,
    "DOWNLOADED": 11,
    "PAUSE": 12,
    "INSTALLING": 13,
    "INSTALLED": 14,
    "FAIL": 15,
    "CANCEL": 16,

    "0": "UNINSTALLED",
    "1": "OPENABLE",
    "2": "NOTSURE",
    "3": "NEEDUPDATE",
    "10": "DOWNLOADING",
    "11": "DOWNLOADED",
    "12": "PAUSE",
    "13": "INSATLLING",
    "14": "INSATLLED",
    "15": "FAIL",
    "16": "CANCEL"
  }
};